/* eslint-disable max-len */
import { useMutation } from '@apollo/client';
import React, { useEffect, useState } from 'react';
import CheckboxNew from '../../../../components/CheckboxNew';
import EmptyPageLoader from '../../../../components/EmptyPageLoader';
import SideDrawer from '../../../../components/SideDrawer';
import useToast from '../../../../customHooks/useToast';
import { MODIFY_ROLE_PERMISSIONS } from '../../../../graphql/admin_mutations';
import { GET_ALL_PERMISSIONS } from '../../../../graphql/admin_queries';
import useCustomQuery from '../../../../network/useCustomQuery';
import Styles from './ViewPermission.module.scss';

interface IViewPermission{
  payload:any;
  onClose:any;
}
const ViewPermission = ({ payload, onClose }:IViewPermission) => {
  const Toast = useToast();
  const [getAllPermissions, allPermissionLoading, allPermissions] = useCustomQuery({
    query: GET_ALL_PERMISSIONS,
    onError: () => {},
    onData: () => {},
  });

  const [modifyCreatePermissions, { loading: modifyPermissionsLoading }] = useMutation<
  { modifyRolePermissions: any },
  any
>(MODIFY_ROLE_PERMISSIONS);

  const [permissionGroups, setPermissionGroups] = useState(null);
  const [allPermissionRec, setAllPermissionRec] = useState(null);
  const [isDisabled, setIsDisabled] = useState(true);

  useEffect(() => {
    getAllPermissions({ variables: { roleId: payload?.id, platform: 'canada' } });
  }, [payload]);

  const checkIfAllPermissionIsSelected = (group:string) => {
    const findPermissionByGroup = allPermissionRec?.filter((list:any) => list?.group === group);
    const findIfNotAllIsChecked = findPermissionByGroup?.find((list:any) => !list?.hasPermission);

    if (findIfNotAllIsChecked) {
      return false;
    }
    if (!findIfNotAllIsChecked) {
      return true;
    }
  };

  useEffect(() => {
    if (allPermissionRec) {
      const record = {};
      allPermissionRec.forEach((permission) => {
        const permisionGroup = permission?.group?.trim?.() || 'Others';

        if (!record[permisionGroup]) {
          const permissionArray = [{
            id: permission?.id,
            hasPermission: permission?.hasPermission,
            ...permission,
          }];
          record[permisionGroup] = {
            group: permisionGroup,
            hasPermission: payload?.name === 'Super Admin' ? true : checkIfAllPermissionIsSelected(permission?.group),
            permissions: permissionArray,
          };
        } else {
          record[permisionGroup].permissions.push({
            id: permission.id,
            hasPermission: permission?.hasPermission,
            ...permission,
          });
        }
      });
      const recordPermissionArr = Object.values(record);
      setPermissionGroups(recordPermissionArr);
    }
  }, [allPermissionRec]);

  useEffect(() => {
    if (allPermissions?.getAllPermissions?.permissions) {
      setAllPermissionRec(allPermissions?.getAllPermissions?.permissions);
    }
  }, [allPermissions]);

  const handleUpdate = (id:string, group:string) => {
    const findSelectedValue = permissionGroups?.find((list:any) => list?.group === group);

    if (findSelectedValue) {
      const checkThroughPermissions = permissionGroups?.map((details) => {
        const updatedData = details?.group === findSelectedValue?.group ? {
          group: details?.group,
          permissions: id === 'all' ? details?.permissions?.map((permData:any) => ({
            ...permData,
            hasPermission: !details?.hasPermission,
          })) : details?.permissions?.map((permission) => (permission?.id === id ? { ...permission, hasPermission: !permission?.hasPermission } : { ...permission })),
          hasPermission: id === 'all' ? !details?.hasPermission : false,

        } : details;
        return updatedData;
      });

      setPermissionGroups(checkThroughPermissions);
    }
  };

  const handleUpdatePermissions = async () => {
    const selectedPermissionIds:any = [];
    const unCheckPermissionsIds:any = [];
    permissionGroups?.forEach((groupName: any) => {
      groupName?.permissions?.forEach((permission: any) => {
        if (permission?.hasPermission) {
          selectedPermissionIds?.push(permission?.id);
        } else {
          unCheckPermissionsIds?.push(permission?.id);
        }
      });
    });

    const letCeateModifyData = {
      roleId: payload?.id,
      permissionIds: selectedPermissionIds,
      deletedPermissionIds: unCheckPermissionsIds,
    };

    if (!modifyPermissionsLoading) {
      try {
        const res = await modifyCreatePermissions({
          variables: letCeateModifyData,
        });

        if (res?.data?.modifyRolePermissions && res?.data?.modifyRolePermissions?.status === 200) {
          Toast.success(res?.data?.modifyRolePermissions?.message || 'Operation was successful');
          setIsDisabled(true);
          getAllPermissions({ variables: { roleId: payload?.id, platform: 'canada' } });
        } else {
          Toast.error(res?.data?.modifyRolePermissions?.message || 'Operation failed');
        }
      } catch (e) {
        if (e && e.graphQLErrors && e.graphQLErrors.length > 0) {
          Toast.error(e.graphQLErrors[0].message);
        } else {
          Toast.error('Something went wrong');
        }
      }
    }
  };

  return (
    <div className={Styles.wrapper}>
      <SideDrawer
        onClose={onClose}
        title="Role Permissions"
        subtitle="Description of what users should do here."
        optionalHeader={(
          <div className={Styles.wrapper__roleNameAndActionContainer}>
            <div className={Styles.wrapper__roleNameAndAction}>
              <div className={Styles.wrapper__roleName}>
                {payload?.name}

              </div>
              {
                payload?.name !== 'Super Admin' && (
                <div className={Styles.wrapper__permissonAction}>
                  {
                    !allPermissionLoading && (modifyPermissionsLoading ? <span>Loading...</span> : <span onClick={isDisabled ? () => setIsDisabled(false) : handleUpdatePermissions}>{isDisabled ? 'Edit' : 'Save Changes'}</span>)
                  }

                </div>
                )
              }

            </div>
          </div>
        )}
      >
        {
          allPermissionLoading ? <EmptyPageLoader /> : (
            <div className={Styles.wrapper__permissionContainer}>
              <div className={Styles.wrapper__permissionListContainer}>
                <div className={Styles.wrapper__title}>Permissions</div>
                {
                  permissionGroups?.map((groupName:any, index:number) => (
                    <div key={index} className={Styles.wrapper__permissionContainer}>
                      <div className={Styles.wrapper__groupName}>
                        <CheckboxNew
                          isLeftContent
                          width="100%"
                          disabled={(payload?.name === 'Super Admin') || isDisabled}
                          loading={modifyPermissionsLoading}
                          onClick={() => {
                            handleUpdate('all', groupName?.group);
                          }}
                          onChange={() => {
                            handleUpdate('all', groupName?.group);
                          }}
                          name=""
                          value={groupName?.hasPermission}
                          iconColor="white"
                          backgroundColor={groupName?.hasPermission ? 'rgba(18, 18, 18, 1)' : 'white'}
                          height="fit-content"
                        >
                          <span className={Styles.wrapper__checkContent}>
                            {' '}
                            {groupName?.group}
                          </span>

                        </CheckboxNew>
                      </div>
                      {
                        groupName?.permissions?.map((permDetails:any, index:number) => (
                          <div className={Styles.wrapper__permissionName} key={index}>
                            {' '}
                            <CheckboxNew
                              disabled={(payload?.name === 'Super Admin') || isDisabled}
                              isLeftContent
                              width="100%"
                              loading={modifyPermissionsLoading}
                              onClick={() => {
                                handleUpdate(permDetails?.id, groupName?.group);
                              }}
                              onChange={
                                () => {
                                  handleUpdate(permDetails?.id, groupName?.group);
                                }
                              }
                              name=""
                              value={permDetails?.hasPermission}
                              iconColor="white"
                              backgroundColor={permDetails?.hasPermission ? 'rgba(18, 18, 18, 1)' : 'white'}
                              height="fit-content"
                            >
                              <span className={Styles.wrapper__permissionCheckContent}>
                                {' '}
                                {permDetails?.name?.split('-')?.join(' ')}
                              </span>

                            </CheckboxNew>
                          </div>
                        ))
                      }

                    </div>
                  ))
                }

              </div>
            </div>
          )
        }

      </SideDrawer>
    </div>
  );
};

export default ViewPermission;
